
import React from 'react'
import PropTypes from 'prop-types'

const SuburbInfo = props => (
  <div>
    <h3 className="content-card_title" style={{ marginBottom: '35px' }}>

      {  props.title.charAt(0).toUpperCase() + props.title.slice(1) }
    </h3>
    <div className="SuburbInfo">

      <div className="SuburbInfo_section">
        <div className="SuburbInfo_title">
          {
            props.data.electedParty
              ? props.data.electedParty
              : ""
          }
        </div>
        <span className="SuburbInfo_info" >
          is the elected party
        </span>
      </div>

    </div>

    <div className="SuburbInfo">
      <div className="SuburbInfo_section">
        <div className="SuburbInfo_info" >
          {props.place} is classified as
        </div>
      </div>
      <div className="SuburbInfo_section">
        <div className="SuburbInfo_title">
          {
            props.data.suburbType
              ? props.data.suburbType
              : ""
          }
        </div>
      </div>
    </div>

  </div>


);


SuburbInfo.propTypes = {
  repeatPercent: PropTypes.number,
  uniquePercent: PropTypes.number,
  averageEvents: PropTypes.number,
  averageEventsByPOI: PropTypes.number
};

SuburbInfo.defaultProps = {
  repeatPercent: undefined,
  uniquePercent: undefined,
  averageEvents: undefined,
  averageEventsByPOI: undefined
};

export default SuburbInfo;
